import { render } from "./NykButton.vue?vue&type=template&id=8ad9d926"
import script from "./NykButton.vue?vue&type=script&lang=js"
export * from "./NykButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__